/**
 * Check if the given searchText is a ISIN code - a 12-character alpha-numerical code
 * @param {string} searchText
 */
export const isIsin = (searchText: string): boolean => {
    return /[a-zA-Z]{2}[0-9a-zA-Z]{9}[0-9]{1}/.test(searchText);
};
